import React from "react";
import {
  Grid,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
} from "@mui/material";

const PhotosSection = ({
  formData,
  handleInputChange,
  handleBooleanChange,
}) => {
  // Handle file uploads separately
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      handleInputChange({
        target: { name, value: files[0] }, // Store File object instead of string
      });
    }
  };
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="body1">
          Souhaitez-vous partager vos photos ?
        </Typography>
        <RadioGroup
          row
          name="partagePhoto"
          value={formData.partagePhoto ? "true" : "false"} // Convert boolean to string
          onChange={handleBooleanChange} // Pass event handler directly
        >
          <FormControlLabel value="true" control={<Radio />} label="Oui" />
          <FormControlLabel value="false" control={<Radio />} label="Non" />
        </RadioGroup>
      </Grid>
      {formData.partagePhoto && (
        <>
          <Grid item xs={12} sm={4}>
            <Typography variant="body2">Photo de Face</Typography>
            <Button variant="contained" component="label">
              Choisir un fichier
              <input
                type="file"
                name="photoDeFace"
                accept="image/*"
                hidden
                onChange={handleFileChange}
              />
            </Button>
            {formData.photoDeFace && (
              <Typography>{formData.photoDeFace.name}</Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="body2">Photo de Côté</Typography>
            <Button variant="contained" component="label">
              Choisir un fichier
              <input
                type="file"
                name="photoDeCote"
                accept="image/*"
                hidden
                onChange={handleFileChange}
              />
            </Button>
            {formData.photoDeCote && (
              <Typography>{formData.photoDeCote.name}</Typography>
            )}
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="body2">Photo de Dos</Typography>
            <Button variant="contained" component="label">
              Choisir un fichier
              <input
                type="file"
                name="photoDeDos"
                accept="image/*"
                hidden
                onChange={handleFileChange}
              />
            </Button>
            {formData.photoDeDos && (
              <Typography>{formData.photoDeDos.name}</Typography>
            )}
          </Grid>
        </>
      )}
    </>
  );
};

export default PhotosSection;
